import {normalizeCriteriaTarget} from "@/pages/admin/CriteriaPage/components/criteriaGridHelpers";

import {fulfilledState, pendingState, rejectedState, resError} from "@helpers";
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import CriteriaService from "@services/CriteriaService";

export const getEditCriteria = createAsyncThunk(
  "criteria/edit",
  async ({id}, {rejectWithValue}) => {
    try {
      const response = await CriteriaService.viewCriteria({id});
      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

export const updateCriteria = createAsyncThunk(
  "criteria/update",
  async ({id, target}, {rejectWithValue}) => {
    try {
      const response = await CriteriaService.updateCriteria({id, target});
      return response.data;
    } catch (err) {
      return rejectWithValue(resError(err));
    }
  },
);

const initialState = {
  target: null,
  initialTarget: null,
  isChanged: false,
  errors: null,
  error: "",
  status: "",
};

const editCriteriaSlice = createSlice({
  name: "edit-criteria",
  initialState,
  reducers: {
    setTarget(state, action) {
      state.target = action.payload;
    },
    setInitialTarget(state, action) {
      state.initialTarget = action.payload;
    },
    setIsChanged(state, action) {
      state.isChanged = action.payload;
    },
    setErrors(state, action) {
      state.errors = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setStatus(state, action) {
      state.status = action.payload;
    },
    clearEdit() {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEditCriteria.pending, (state) => {
        pendingState(state);
      })
      .addCase(getEditCriteria.fulfilled, (state, action) => {
        const normalized = normalizeCriteriaTarget(action.payload);
        state.target = normalized;
        state.initialTarget = normalized;
        fulfilledState(state);
      })
      .addCase(getEditCriteria.rejected, (state, action) => {
        rejectedState(state, action);
      })

      .addCase(updateCriteria.pending, (state) => {
        pendingState(state);
      })
      .addCase(updateCriteria.fulfilled, (state, action) => {
        const normalized = normalizeCriteriaTarget(action.payload);
        state.target = normalized;
        state.initialTarget = normalized;
        fulfilledState(state);
      })
      .addCase(updateCriteria.rejected, (state, action) => {
        rejectedState(state, action);
      });
  },
});

export const {
  setTarget,
  setInitialTarget,
  setIsChanged,
  setErrors,
  setError,
  setStatus,
  clearEdit,
} = editCriteriaSlice.actions;

export default editCriteriaSlice.reducer;
